import { ContentPage } from '../page-factory/content-page';
import { packagesPage } from '../pages/page-packages';
import { getPageMeta } from '../pages/pages-types';

export const meta = () => getPageMeta(packagesPage);

export default function PackagesPage() {
  return <ContentPage {...packagesPage} />;
}
